<template>
  <driver-detail :is-edit="true" :is-new="this.isNew"/>
</template>

<script>
    import DriverDetail from './components/DriverDetail';
    export default {
        name: "EditDriver",
        components: { DriverDetail },
        props: {
            isNew: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>

<style scoped>

</style>
